import { Row, Table as TanstackTable } from '@tanstack/react-table';
import clsx from 'clsx';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui/Stack';
import { ChevronDownIconV2 } from 'src/svgs/Viagogo/goicons/ChevronDownIconV2';
import { ChevronUpIconV2 } from 'src/svgs/Viagogo/goicons/ChevronUpIconV2';

import * as tableStyles from '../components/Table.css';
import * as styles from '../GroupedTable.css';
import { TableRowCheckbox } from './TableCheckbox';

interface GroupHeaderRowProps<T> {
  groupId: string;
  childData: T[];
  isExpanded: boolean;
  toggleExpanded: () => void;
  renderGroupHeader?: (groupId: string, groupData: T[]) => React.ReactNode;
  showCheckbox?: boolean;
  parentRow: Row<T>;
  table: TanstackTable<T>;
  getGroupId?: (data: T) => string | null | undefined;
  getItemId?: (data: T) => string | undefined;
  isSelectionDisabled?: (data: T) => string | undefined;
  tableContainerWidth: string;
  selected?: boolean;
  active?: boolean;
}

export function GroupHeaderRow<T>({
  groupId,
  childData,
  isExpanded,
  toggleExpanded,
  renderGroupHeader,
  showCheckbox,
  parentRow,
  table,
  getGroupId,
  getItemId,
  isSelectionDisabled,
  tableContainerWidth,
  selected,
}: GroupHeaderRowProps<T>) {
  const Icon = isExpanded ? ChevronUpIconV2 : ChevronDownIconV2;

  return (
    <td className={clsx(styles.groupHeaderCellTd)} colSpan={1}>
      <div
        className={clsx(
          styles.groupHeaderCell,
          showCheckbox && styles.groupHeaderCellWithCheckbox,
          selected && tableStyles.tableRowSelected
        )}
        style={{ width: `var(${tableContainerWidth})` }}
      >
        <Stack
          gap="m"
          alignItems="center"
          direction="row"
          style={{ flex: 1, overflow: 'auto', minWidth: 0 }}
        >
          {showCheckbox && (
            <div style={{ paddingRight: vars.spacing.xxs }}>
              <TableRowCheckbox
                row={parentRow}
                table={table}
                getGroupId={getGroupId}
                getItemId={getItemId}
                isSelectionDisabled={isSelectionDisabled}
              />
            </div>
          )}
          {renderGroupHeader &&
            groupId &&
            renderGroupHeader(groupId, childData)}
        </Stack>
        <Icon
          size={vars.iconSize.s}
          withHoverEffect
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            toggleExpanded();
          }}
        />
      </div>
    </td>
  );
}
